var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","tag":"section"}},[_vm._v("\n  22222\n")])}
var staticRenderFns = []

export { render, staticRenderFns }